import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { PdfReader } from "../../utils/DocumentViewer";
class OtherClauses extends React.Component {
  state = {
    showUploadDocument: false,
    fileName: "",
    documentType: "",
    uploadedDocuments: [],
    currentDocument: "",
    pageNo: 1,
    documentTable: [],
    documentNamesAfterAdd: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      otherClauses: this.props.otherClauses,
      leaseDocuments: this.props.leaseDocuments,
    };
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          {this.state.otherClauses != null &&
            this.state.otherClauses.map(function (name, index) {
              return (
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Clause Name <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            <a
                              style={{ width: "607px" }}
                              href="javascript:void(0)"
                              className="clauseNameLink"
                              onClick={(e) => {
                                e.preventDefault();
                                var currentDocumentURL =
                                  this.state.leaseDocuments.filter(
                                    (obj) =>
                                      obj.leaseDocumentType == name.document
                                  ); //name.url;
                                console.log(
                                  currentDocumentURL,
                                  "currentDocumentURL"
                                );
                                this.state.currentDocument =
                                  currentDocumentURL[0]["url"];
                                this.state.pageNo = name.pageNo;
                                this.openModal();
                              }}
                            >
                              {name.clauseName}
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Details
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.details}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Document Name
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.document}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Document Page Number
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.pageNo}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Notes
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {this.props.notes}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }, this)}
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              size="lg"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Document</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <PdfReader
                      url={this.state.currentDocument}
                      pageNumber={this.state.pageNo}
                    />
                  </div>
                </div>
              </Modal.Body>
              {/* <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={this.closeModal}
                  >
                    Close
                  </Button>
                </Modal.Footer> */}
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OtherClauses);
